<ion-content appIonScrollbar [scrollbarWidth]="0">
  <ion-grid>
    <ion-row class="top-row">
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1>{{ "Services" | translate }}</h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" *ngFor="let item of dataServ.liveRequests">
        <ng-container
          *ngIf="
            item.data.menu_categories[0].menu_items[0]
              .accept_requests_outside_hours
          "
        >
          <ion-card (click)="detail(item.data)">
            <ion-img
              [src]="
                item.data.menu_categories[0]?.menu_items[0]?.images.length > 1
                  ? item.data.menu_categories[0]?.menu_items[0]?.images[1].url
                  : item.data.menu_categories[0]?.menu_items[0]?.images[0].url
              "
              *ngIf="item.data.menu_categories[0]?.menu_items[0]?.images"
            ></ion-img>

            <div class="bottom">
              <ion-text color="white">
                <h2>
                  <b [innerHtml]="item.data.title | caption | translate"></b>
                </h2>
              </ion-text>
            </div>
          </ion-card>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
